import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube, FaCcVisa, FaCcMastercard, FaCcPaypal, FaCcAmex } from "react-icons/fa";
import { useTranslation } from "./hooks/useTranslation";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-container">
          {/* About Section */}
          <div className="footer-section animate-fadeIn">
            <h3>{t.companyName}</h3>
            <p>
              {t.aboutDescription || "We are a dedicated travel destination management company in Sri Lanka, offering custom tours & holiday packages."}
            </p>
            <div className="social-icons">
              {/* <a href="#" aria-label="Facebook"><FaFacebook /></a>
              <a href="#" aria-label="Instagram"><FaInstagram /></a>
              <a href="#" aria-label="Twitter"><FaTwitter /></a>
              <a href="#" aria-label="Youtube"><FaYoutube /></a> */}
            </div>
          </div>

          {/* Quick Links Section */}
          <div className="footer-section animate-fadeIn">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/home">{t.home}</Link></li>
              <li><Link to="/about">{t.about}</Link></li>
              <li><Link to="/testimonials">{t.testimonials}</Link></li>
              <li><Link to="/contact">{t.contact}</Link></li>
            </ul>
          </div>

          {/* Contact Section */}
          <div className="footer-section animate-fadeIn">
            <h3>{t.contactTitle}</h3>
            <p>Email: lankatravelhub.lk@gmail.com</p>
            <p>Phone: +94 72 051 2976</p>
            <p>Location: Watabage Junction, Panadura, Sri Lanka</p>
          </div>

          {/* Payment Options */}
          <div className="footer-section animate-fadeIn">
            <h3>We Accept</h3>
            <div className="payment-icons">
              <FaCcVisa />
              <FaCcMastercard />
              <FaCcPaypal />
              <FaCcAmex />
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} {t.companyName} | All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
